import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MaterialModule } from '../../material/material.module';
import { CustomDropdownModule } from '../custom-dropdown/custom-dropdown.module';
import { ConfirmPopupModule } from 'src/app/modules/confirm-popup/confirm-popup.module';
import { RetriveReportsFetchComponent } from './retrive-reports-fetch.component';

@NgModule({
  declarations: [RetriveReportsFetchComponent],
  imports: [
    CommonModule,
    MaterialModule,
    CustomDropdownModule,
    ConfirmPopupModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
  ],
   exports: [
      RetriveReportsFetchComponent,
  
      
  
    ]
})
export class RetriveReportsFetchModule { }
